export interface Any {
  type: 'Any';
  terms: Term[];
}
export interface All {
  type: 'All';
  terms: Term[];
}
export type Term = string | Any | All;

export const any = (...terms: Term[]): Any => ({ type: 'Any', terms });
export const all = (...terms: Term[]): All => ({ type: 'All', terms });

export function test(term: Term, input: string): boolean {
  if (typeof term === 'string') {
    return new RegExp(
      `(?:^|[^\\w'-])${escapeRegExp(term)}(?:[^\\w'-]|$)`,
      'i'
    ).test(input);
  }

  return term.terms[term.type === 'All' ? 'every' : 'some'](t =>
    test(t, input)
  );
}

function escapeRegExp(input: string) {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
